import "../App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "pages/Homepage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="expanded-item" element={<Homepage />}>
          <Route path=":itemId" element={<Homepage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
